import React, { useState } from "react";
import banner from "../../assets/images/FAQs-page-banner.avif";
import { FaSearch } from "react-icons/fa";
import "../../../src/App.css";
import CustomBanner from "../../components/CustomBanner";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";

const FaqPage = () => {
  const [activeCategory, setActiveCategory] = useState("About Apptalyst");
  const [activeIndex, setActiveIndex] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const faqData = {
    "About Apptalyst": [
      {
        id: "1",
        question: "Who founded Apptalyst and when was it established?",
        answer:
          "Apptalyst was founded in April 2025 by Shahan Salam and Affan Salim. It is a privately held company, and both founders are deeply rooted in the software development industry.",
      },
      {
        id: "2",
        question:
          "How large is your team and what is your collective experience? ",
        answer:
          "Our team consists of over 20 members. Most of our team members have more than three years of professional experience.",
      },
      {
        id: "3",
        question: "Where is your office located?",
        answer:
          "Our headquarters is located in Great Falls, Fairfax, Virginia; making us a local software company for the DMV area. We also have an office in Karachi, Pakistan. We welcome clients to either office for in-person meetings.",
      },
      {
        id: "4",
        question:
          "How do you work with clients outside of the Fairfax, Virginia area?",
        answer:
          "We work with clients globally through remote and virtual arrangements for ongoing communication. We are also available for in-person meetings as needed.",
      },
      {
        id: "5",
        question:
          "What makes Apptalyst different from other development agencies and what is your company culture like?",
        answer:
          " Apptalyst distinguishes itself through transparency, excellent customer service, technical brilliance, and a commitment to excellence on every project. Our company culture promotes collaborative growth and good business practices.",
      },
    ],
    "Process & Communication": [
      {
        id: "1",
        question:
          "What does your software development process look like and what methodologies (e.g., Agile, Scrum) do you use?",
        answer:
          "We adapt our project management protocols to fit a project's specific nature, scope, and timeline. However, we prefer the Agile methodology to promptly deliver core project requirements to business owners.",
      },
      {
        id: "2",
        question:
          "What is a typical project timeline and how do you estimate a project's timeline?",
        answer:
          "Project timelines vary depending on the scope and effort required. A project can be delivered in as little as one week or may take up to four months or more.",
      },
      {
        id: "3",
        question:
          "How often will I receive communications and updates during my project?",
        answer:
          "We provide our clients with daily updates through various communication channels, including Zoom meetings, emails, calls, and text messages.",
      },
      {
        id: "4",
        question: "How do you handle client feedback and revisions?",
        answer:
          "We carefully document and review all client feedback. Based on our experience, we suggest possibilities and recommendations to ensure complete creative fulfillment for every detail of a client's project.",
      },
      {
        id: "5",
        question:
          "Do you offer support and maintenance after the project is launched?",
        answer:
          "Yes, we offer affordable post-launch support and maintenance packages on a monthly or yearly basis.",
      },
      {
        id: "6",
        question:
          "What do you need from me (the client) to get a project started?",
        answer:
          "We only expect clients to have a basic idea of their project's objectives; from there, we are happy to consult on the rest of the details. We also use questionnaires to help document a client's requirements.",
      },
    ],
    " Payments & Contracts": [
      {
        id: "1",
        question: "What are your payment terms and project payment structure?",
        answer:
          "While our payment terms can vary, most projects follow a milestone-based payment and delivery structure. Payments for completed milestones and milestones that are in progress are typically non-refundable.",
      },
      {
        id: "2",
        question: "What payment methods do you accept?",
        answer:
          "We accept bank transfers, credit/debit card payments, Zelle, and Venmo.",
      },
      {
        id: "3",
        question:
          "How do you handle changes to the project scope or new feature requests?",
        answer:
          "We typically accommodate minor deviations in a project's scope. For more complex changes, we manage scope change requests by allocating additional resources, which may incur additional charges.",
      },
      {
        id: "4",
        question:
          "How do you estimate project costs and do you offer fixed-price contracts, hourly rates, or both?",
        answer:
          "Project costs are estimated based on the development effort, hours, and the number of skilled resources required. We primarily work on a fixed lump-sum service cost but are also open to contracts for hourly work.",
      },
      {
        id: "5",
        question: "Do you handle payments from global clients?",
        answer:
          " Yes, we accept bank (SWIFT) transfers and debit/credit card payments from clients anywhere in the world.",
      },
      {
        id: "6",
        question: 'Do you work on a "work for hire" basis?',
        answer:
          'Yes, in exceptional cases, such as for prolonged partnerships or contracts, we can allocate resources on a "work for hire" basis.',
      },
    ],

    "Intellectual Property": [
      {
        id: "1",
        question:
          "Who owns the intellectual property (IP) and source code at the end of the project? ",
        answer:
          " The client receives full ownership of the intellectual property and source code, as explicitly stated in our contracts.",
      },
      {
        id: "2",
        question:
          "Do you sign Non-Disclosure Agreements (NDAs) to protect project confidentiality? ",
        answer:
          "Yes, we sign NDAs that include all necessary confidentiality clauses, which are compliant with and enforceable by local and international law.",
      },
      {
        id: "3",
        question:
          "What measures do you take to protect client data and trade secrets? ",
        answer:
          " In addition to legally enforceable contracts, we have strict internal protocols to ensure client data and trade secrets are always secure.",
      },
      {
        id: "4",
        question:
          "What is your policy on code reuse? Do you use third-party or open-source libraries in your projects? ",
        answer:
          ' Yes, like most modern software development companies, we leverage a combination of custom code and pre-existing, trusted open-source libraries. This standard industry practice allows us to build powerful, secure, and reliable applications more efficiently without "reinventing the wheel." The use of these components does not affect your ownership of the final, custom-built product. You will own the proprietary source code we write specifically for your project. ',
      },
    ],

    Services: [
      {
        id: "1",
        question: "Do you offer technical consulting and advisory services? ",
        answer:
          "Yes. We are pleased to offer complimentary consultations to small businesses. We also provide comprehensive technical and digital advisory services for corporations. ",
      },
      {
        id: "2",
        question:
          "Can you provide examples of your experience in specific industries? ",
        answer:
          "We present relevant work samples and discuss our industry-specific expertise during our discovery and consultation sessions. Our portfolio is also available for review. ",
      },
      {
        id: "3",
        question: "Do you provide custom database design and development? ",
        answer:
          "Yes, we conceptualize, design, and develop robust and scalable databases for custom back-ends and unique project requirements. ",
      },
      {
        id: "4",
        question: "Do you offer API development and integration? ",
        answer:
          " Yes, we develop APIs for the software we build and also provide expert integration services with external APIs. ",
      },
      {
        id: "5",
        question:
          "Can you manage cloud deployment and hosting for my product? ",
        answer:
          "We provide expert consultation and services for scalable cloud deployment and hosting for web and mobile applications. ",
      },
      {
        id: "6",
        question: "How do you approach Quality Assurance (QA) and testing? ",
        answer:
          "We maintain the highest QA standards and implement test-driven development. This ensures each stage of the development process is validated for technical robustness, user acceptance, and project success objectives. ",
      },
    ],

    "Careers at Apptalyst": [
      {
        id: "1",
        question: "How can I apply for a position at Apptalyst? ",
        answer:
          "You can apply for our open positions on LinkedIn, Glassdoor, and Indeed. We also invite you to get in touch with us via email at hr@apptalyst.com. ",
      },
      {
        id: "2",
        question:
          "What is your hiring process like, and how long does it usually take?",
        answer:
          "Our hiring process typically involves an initial technical interview with shortlisted candidates. Successful candidates then proceed to a brief final interview with department heads or management. The entire process usually takes one to two weeks. ",
      },
      {
        id: "3",
        question:
          "What is the work environment and company culture like at Apptalyst? ",
        answer:
          "At Apptalyst, we encourage and empower professional growth. Our work culture prioritizes efficiency and flexibility to ensure a positive and productive work experience. ",
      },
    ],
  };
  const filteredFaqs = faqData[activeCategory] || [];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    setActiveIndex(null);
  };

  return (
    <>
      <Head>
        <title>Find answers to frequently asked questions.</title>
        <meta
          name="description"
          content="Answers to FAQs about us, our process, easy payments, how we secure intellectual property, all of our services in general and careers at our company."
        />
        <link rel="canonical" href="https://apptalyst.com/faqs " />
      </Head>
      <CustomBanner bgImg={banner}>
        <div className="w-full   flex-col justify-start  text-white  space-y-6">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[36px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1] font-bold text-"
          >
            Have a Question?
          </motion.h1>

          <div className="   rounded overflow-hidden shadow">
            <textarea
              type="text"
              placeholder="Write your query"
              className="w-full px-4 py-3 text-dark focus:outline-none rounded border"
            ></textarea>
            <br />
            <input
              type="text"
              placeholder="Email"
              className="w-full px-4 py-3 text-dark focus:outline-none rounded"
            />
            {/* <button className="bg-[#FFC067] text-dark px-4 py-3 hover:bg-gray-200 transition mx-2 rounded">
      <FaSearch/>
    </button> */}
          </div>
          <div className="relative z-10">
            <button className="px-6 py-3 bg-[#FFC067] text-dark font-bold rounded shadow  transition  text-base md:text-lg hover-liner  ">
              Submit
            </button>
          </div>
        </div>
      </CustomBanner>

      <div className=" container my-20 md:my-32   ">
        <div className="w-12/12 md:w-11/12 lg:w-10/12 mx-auto px-4 grid grid-cols-1 lg:grid-cols-6 gap-4">
          {/* Sidebar Navigation */}
          <div className="hidden lg:block lg:col-span-2 shadow-xl rounded-md  overflow-hidden  ">
            <div className="   overflow-hidden px-4 my-3 ">
              <motion.h2
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
                className="text-2xl pt-5 font-medium text-dark  border-gray-200 mb-3"
              >
                FAQs
              </motion.h2>
              <hr />
              <ul className=" divide-gray100 space-y-2 mt-1">
                {Object.keys(faqData).map((category) => (
                  <li key={category}>
                    <button
                      onClick={() => handleCategoryClick(category)}
                      className={`w-full text-left font-semibold px-7 py-4 focus:outline-none   ${
                        activeCategory === category
                          ? " bg-[#f3ebfa]    rounded font-semibold text-dark"
                          : "text-dark hover:bg-gray-100 "
                      }`}
                    >
                      {category}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Mobile Dropdown Navigation - Smooth Version */}
          <div className="lg:hidden shadow rounded-3xl mb-6  relative">
            {" "}
            {/* Added relative here */}
            <div className="px-4 py-5">
              <h3 className="text-2xl font-medium text-gray-800 border-b border-gray-100 pb-3 mb-3">
                FAQ's
              </h3>

              {/* Changed container structure */}
              <div className="relative w-full " style={{ zIndex: 1 }}>
                {" "}
                {/* Increased z-index */}
                {/* Dropdown Button */}
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 bg-gray-50 rounded-lg text-
         focus:outline-none "
                >
                  <span>{activeCategory || "Select a category"}</span>
                  <svg
                    className={`w-5 h-5 ml-2 transition-transform ${
                      isDropdownOpen ? "transform rotate-180" : ""
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                {/* Dropdown Options - Removed absolute positioning */}
                {isDropdownOpen && (
                  <div
                    className="mt-1 w-full bg-white p-2 rounded-lg shadow-lg border border-gray-200 absolute"
                    onMouseLeave={() => setIsDropdownOpen(false)}
                  >
                    <ul className="max-h60 h-full overflow-y-auto space-y-2">
                      {Object.keys(faqData).map((category) => (
                        <li key={category}>
                          <button
                            onClick={() => {
                              handleCategoryClick(category);
                              setIsDropdownOpen(false);
                            }}
                            className={`w-full text-left px-4 py-3  text-dark font-semibold rounded ${
                              activeCategory === category
                                ? "bg-[#f3ebfa] text-dark "
                                : "hover:bg-gray-100 "
                            }`}
                          >
                            {category}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* FAQ Content */}
          <div className="lg:col-span-4 bg-white rounded-md  overflow-hidden shadow-xl px-4 py-4 ">
            <ul className="divide-y divide-gray-100 space-y-4">
              {filteredFaqs.map((faq, index) => (
                <li
                  key={faq.id}
                  className={`px-6 py-4 ${
                    activeIndex === index
                      ? " bg-[#f3ebfa]  text-dark font-semibold "
                      : "bg-gray-50  text-dark font-semibold"
                  } rounded-lg `}
                >
                  <div
                    className={`flex justify-between items-center cursor-pointer ${
                      activeIndex === index ? "mb-2" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                  >
                    <div className="flex items-center md:space-x-3   w-full">
                      <span
                        className={`font-semibold  text-5xl hidden md:block    ${
                          activeIndex === index ? "text-dark" : "text-gray-300"
                        }`}
                      >
                        0{index + 1}
                      </span>
                      <div className="flex justify-between w-full space-x-1">
                        <h3
                          className={`font-semibold ${
                            activeIndex === index ? "text-dark" : "text-dark"
                          }`}
                        >
                          {faq.question}
                        </h3>
                        <span
                          className={`text-xl text-gray-500 ${
                            activeIndex === index ? "rotate180" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 transition-transform duration-300"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d={
                                activeIndex === index
                                  ? "M5 12h14"
                                  : "M12 6v6m0 0v6m0-6h6m-6 0H6"
                              }
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* {activeIndex === index && (
                  <div className="mt-6 text-dark  ">
                    <p>{faq.answer}</p>
                  </div>
                )} */}

                  <div
                    className={`overflow-hidden transition-all duration-500 ease-in-out ${
                      activeIndex === index
                        ? "max-h-96 opacity-100 mt-6 font-normal"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="px-2 md:px-0 text-dark">
                      <p className="whitespace-pre-line text-base leading-[1.625rem]">{faq.answer}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqPage;
